module.exports = __webpack_public_path__ + "media/components/country-flag/static/bn-31eb929b9bf8797795e281b1fee412cc.svg";